import ReactDOM from "react-dom/client";

// library styles
import "react-toastify/dist/ReactToastify.css";
import "sweetalert2/src/sweetalert2.scss";
import "react-loading-skeleton/dist/skeleton.css";

// application styles
import "assets/index.scss";

import reportWebVitals from "reportWebVitals";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<App />);

reportWebVitals();
